module.exports = __webpack_public_path__ + "static/media/logo.60f84c43.png";